import React, { useState } from 'react'
import SectionHeading from '../common/SectionHeading'
import SupplierCard from './SupplierCard'

// "Supplier performance" section: suppliers sourcing the buyer's orders.
const SupplierPerformance = ({ suppliers }) => {
    const [showAll, setShowAll] = useState(false)
    const list = suppliers ?? []
    if (list.length === 0) return null

    const activeSuppliers = list.filter(
        (supplier) => supplier.supplierStatus === 'ACTIVE'
    )
    const otherSuppliers = list.filter(
        (supplier) => supplier.supplierStatus !== 'ACTIVE'
    )

    const visibleSuppliers = showAll
        ? [...activeSuppliers, ...otherSuppliers]
        : activeSuppliers

    return (
        <section className='pt-8'>
            <SectionHeading title='Supplier performance' className='mb-1' />
            <p className='regular-12 text-[#999a9d] mb-3'>
                Suppliers sourcing your orders
            </p>
            <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4'>
                {visibleSuppliers.map((supplier) => (
                    <SupplierCard key={supplier.id} supplier={supplier} />
                ))}

                {!showAll && otherSuppliers.length > 0 && (
                    <div className='flex items-center justify-center min-h-[128px]'>
                        <button
                            type='button'
                            onClick={() => setShowAll(true)}
                            className='inline-flex items-center justify-center border border-[#e9e9ea] text-[#21242b] hover:bg-[#f4f4f5] transition-colors regular-12 weight-500 h-9 px-6'
                        >
                            View all inactive and archived suppliers
                        </button>
                    </div>
                )}
            </div>
        </section>
    )
}

export default SupplierPerformance
